// PLACEHOLDER DATA — replace with Supabase query.
// Playbook resources: PDFs and training videos for players and parents.

export interface YouTubeVideo {
  title: string;
  youtubeUrl: string;
  thumbnail: string;
  isExternal?: boolean;
}

export interface PlaybookResources {
  playbookPdfUrl: string;
  playbookPrintablePdfUrl: string;
  playbookPreviewImage: string;
  greenlightShootingPdfUrl: string;
  greenlightPreviewImage: string;
  youtubeVideos: YouTubeVideo[];
}

export const playbookResources: PlaybookResources = {
  playbookPdfUrl: "#",
  playbookPrintablePdfUrl: "#",
  playbookPreviewImage:
    "https://mbqtdfdhqbpbcfqzdbso.supabase.co/storage/v1/object/public/site-assets/playbook-preview-01.jpg",
  greenlightShootingPdfUrl: "#",
  greenlightPreviewImage:
    "https://mbqtdfdhqbpbcfqzdbso.supabase.co/storage/v1/object/public/site-assets/greenlight-preview-01.jpg",
  youtubeVideos: [
    {
      title: "EUROPEAN BALL SCREEN OFFENSE",
      youtubeUrl: "https://youtu.be/p0S6eIeIDuY",
      thumbnail: "https://img.youtube.com/vi/p0S6eIeIDuY/hqdefault.jpg",
    },
    {
      title: "TYLER RELPHS TENNIS BALL WORKOUT",
      youtubeUrl: "https://www.youtube.com/watch?v=4tGu_sE4nB4",
      thumbnail: "https://img.youtube.com/vi/4tGu_sE4nB4/hqdefault.jpg",
    },
    {
      title: "AIR ALERT",
      youtubeUrl: "https://www.airalert.com/en/jump-training-online.html",
      thumbnail:
        "https://mbqtdfdhqbpbcfqzdbso.supabase.co/storage/v1/object/public/site-assets/airalert-thumb-01.jpg",
      isExternal: true,
    },
    {
      title: "SHOT MECHANICS ... SHOOT LIKE STEPH CURRY",
      youtubeUrl: "https://www.youtube.com/watch?v=nDMDOZW6rPs",
      thumbnail: "https://img.youtube.com/vi/nDMDOZW6rPs/hqdefault.jpg",
    },
  ],
};